import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

export const LLM_CHAT_ANALYTICS_ACTIONS = {
  SUBMITTED_LLM_CHAT_REACTION_FEEDBACK: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'submitted_llm_chat_reaction_feedback',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SAVED_LLM_GENERATED_DOCUMENT: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'saved_llm_generated_document',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SENT_LLM_CHAT_MESSAGE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'sent_llm_chat_message',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_LLM_CHAT: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_llm_chat',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_SUGGESTED_ACTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_suggested_action',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_LLM_CHAT_FROM_SUGGESTED_ACTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'created_llm_chat_from_suggested_action',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_LLM_CHAT_FROM_HISTORY: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_llm_chat_from_history',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_AI_SIDEPANEL: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_ai_sidepanel',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_AI_TENANT_SETTINGS: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_ai_tenant_settings',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_AI_GENERATED_QUESTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_ai_generated_question',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DISPLAYED_AI_GENERATED_QUESTIONS: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'displayed_ai_generated_questions',
    actionCategory: ACTION_CATEGORY.READ,
  },
  VIEWED_RELEVANT_ITEMS_EXPLORE_BUTTON: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_relevant_items_explore_button',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_RELEVANT_ITEMS_EXPLORE_BUTTON: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_relevant_items_explore_button',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  VIEWED_AI_TRIAL_HOMEPAGE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_ai_trial_homepage',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_AI_TRIAL_SIGNUP_MODAL: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_ai_trial_signup_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_EMAIL_IN_AI_TRIAL_SIGNUP_MODAL: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'submitted_email_in_ai_trial_signup_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_FORM_IN_AI_TRIAL_SIGNUP_MODAL: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'submitted_form_in_ai_trial_signup_modal',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ENDED_COMPOSE_REALTIME_VOICE_SESSION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'ended_compose_realtime_voice_session',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
